import { readonly, ref } from 'vue'
import { tryOnScopeDispose } from './tryOnScopeDispose'

export function useTimeout(fn, interval = 1000, options = {}) {
  let timer = null

  const { immediate = true } = options
  const isPending = ref(false)

  const start = () => {
    stop()
    isPending.value = true
    timer = setTimeout(() => {
      timer = null
      isPending.value = false
      fn()
    }, interval)
  }

  const stop = () => {
    isPending.value = false
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  if (immediate) {
    start()
  }

  tryOnScopeDispose(() => {
    // stop()
  })

  return {
    isPending: readonly(isPending),
    start,
    stop,
  }
}
